import { useState, useEffect, useRef } from "react";
import useStyles from "./styles/workoutplan";
import { workoutPlanData } from "../../static/new-landing-page/new-landing-data";
import ButtonBlue from "../../components/ButtonBlue";
import { withTranslation } from "../../i18n";

const WorkoutPlan = ({ t, i18n, redirect }) => {
    const language = i18n.language
    const data = workoutPlanData[language] || workoutPlanData.en
    const [selectedTab, setSelectedTab] = useState(data.tab[0])
    const [isPaused, setIsPaused] = useState(false)
    const classes = useStyles();
    const intervalRef = useRef(null)

    // Auto pindah tab setiap 5 detik
    useEffect(() => {
        if (!isPaused) {
            intervalRef.current = setInterval(() => {
                setSelectedTab(prevTab => {
                    const currentIndex = data.tab.findIndex(tab => tab.key === prevTab.key)
                    const nextIndex = (currentIndex + 1) % data.tab.length
                    return data.tab[nextIndex]
                })
            }, 5000)
        }

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current)
            }
        }
    }, [isPaused, data.tab])

    // Pause auto pindah saat hover
    const handleMouseEnter = () => {
        setIsPaused(true)
        if (intervalRef.current) {
            clearInterval(intervalRef.current)
        }
    }

    // Resume auto pindah saat mouse leave
    const handleMouseLeave = () => {
        setIsPaused(false)
    }

    // Handle tab click - pause auto pindah dan update tab
    const handleTabClick = (item) => {
        setIsPaused(true)
        setSelectedTab(item)
        // Clear interval jika ada
        if (intervalRef.current) {
            clearInterval(intervalRef.current)
        }
    }

    function renderLeft() {
        return (
            <div className={classes.ctnLeft}>
                <div className={classes.leftWrapper}>
                    <h2 className={classes.title1}>{data.title1}{" "}
                        <span className={classes.title2}>{data.title2}</span>
                    </h2>

                    <div className={classes.tabContainer}>
                        <div className={classes.ctnTab}>
                            {data.tab.map((item, index) => (
                                <div
                                    className={`${classes.tabItem} ${selectedTab.key === item.key ? classes.active : ''}`}
                                    key={index}
                                    onClick={() => handleTabClick(item)}
                                    onMouseEnter={handleMouseEnter}
                                    onMouseLeave={handleMouseLeave}
                                    onTouchStart={() => handleTabClick(item)}
                                >
                                    <span>{item.title}</span>
                                </div>
                            ))}
                            <div className={classes.ctnTabMobile}>
                                &nbsp;
                            </div>
                        </div>
                    </div>
                    <div className={classes.ctnButtonDesktop}>
                        <ButtonBlue isPulse onClick={redirect} label={data.button} />
                    </div>
                </div>
            </div>
        )
    }

    function renderRight() {
        return (
            <div className={classes.ctnRight}>
                <img
                    key={`desktop-${selectedTab.key}`}
                    src={selectedTab.desktopImage}
                    alt="workout-plan"
                    loading="lazy"
                    className={classes.desktopImage}
                />
                <img
                    key={`mobile-${selectedTab.key}`}
                    src={selectedTab.mobileImage}
                    alt="workout-plan"
                    loading="lazy"
                    className={classes.mobileImage}
                />
                <div className={classes.ctnButtonMobile}>
                    <ButtonBlue isPulse onClick={redirect} label={data.button} />
                </div>
            </div>
        )
    }

    return (
        <div className={classes.root}>
            <div className={classes.container}>
                {renderLeft()}
                {renderRight()}
            </div>
        </div>
    )
}

export default withTranslation(["myfitsociety"])(WorkoutPlan);